var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ckeditor-view",staticStyle:{"display":"inline-block"}},[_c('textarea',{attrs:{"id":_vm.instanceId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }